import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;


export async function tvNanoTempToken(data) {
    
    try {
        const response = await serviceContext.post(ReportsURL + "nano/tv/auth", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function tvFlashTempToken(data) {
    
    try {
        const response = await serviceContext.post(ReportsURL + "flash/tv/auth", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function cricketScoreTempToken(data) {
    
    try {
        const response = await serviceContext.post(ReportsURL + "cricket/score/auth", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function lmtScoreTempToken(data) {
    
    try {
        const response = await serviceContext.post(ReportsURL + "lmt/score/auth", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};